import { action, observable, makeObservable, computed } from 'mobx';
import { parseNumberByPrecision } from '../helpers/parseNumberByPrecision';
import { applicationStore } from './applicationStore';

class UserInfoStore {
  betAmount = 0.0001;

  userBalance = 0;

  demoBalance = 100000;

  limits = null;

  precision = 2;

  rate = 1;

  userId = '';

  currencySymbolOrCode = '';

  quickBets = [];

  constructor() {
    makeObservable(this, {
      rate: observable,
      userId: observable,
      quickBets: observable,
      precision: observable,
      betAmount: observable,
      balance: computed,
      currencySymbol: computed,
      userBalance: observable,
      demoBalance: observable,
      currencySymbolOrCode: observable,
      limits: observable.deep,
      setRate: action.bound,
      setUserId: action.bound,
      setLimits: action.bound,
      setQuickBets: action.bound,
      setPrecision: action.bound,
      setBetAmount: action.bound,
      setCurrencyCode: action.bound,
      setUserBalance: action.bound,
      setUserConfigs: action.bound,
    });
  }

  get balance() {
    const { isDemo } = applicationStore;
    return isDemo ? this.demoBalance : this.userBalance;
  }

  get currencySymbol() {
    const { isDemo } = applicationStore;
    return isDemo ? 'FUN' : this.currencySymbolOrCode;
  }

  setCurrencyCode(code) {
    this.currencySymbolOrCode = code;
  }

  setUserId(id) {
    this.userId = id;
  }

  setUserConfigs({ rate, gameBalance, precision }) {
    this.setRate(rate);
    this.setUserBalance(gameBalance);
    this.setPrecision(precision);
  }

  setRate(rate) {
    this.rate = rate;
  }

  setPrecision(precision) {
    this.precision = precision;
  }

  setLimits(limits) {
    this.limits = limits;
    this.betAmount = limits.minBet;
  }

  setUserBalance(balance) {
    this.userBalance = balance;
  }

  setDemoBalance(demoBalance) {
    this.demoBalance = parseNumberByPrecision(demoBalance, 1);
  }

  setBetAmount(betAmount) {
    this.betAmount = betAmount;
  }

  setQuickBets(quickBets, chipsColors) {
    this.quickBets = [...quickBets].map((chip, index) => ({
      chip,
      color: chipsColors[index],
    }));
  }
}

export const userInfoStore = new UserInfoStore();
